import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["css", "asChild", "as", "style", "className", "options", "name", "onChange", "id", "disabled", "hasError", "onCreateOption", "value", "hideDropdownIndicator", "isMulti", "openMenuOnClick", "renderOption", "menuPlacement", "menuPosition", "portalMenu", "icon"];
import React, { useMemo } from "react";
import Creatable from "react-select/creatable";
import useGetCustomComponents from "../hooks/useGetCustomComponents";
import useMenuPositionProps from "../hooks/useMenuPositionProps";
import { getSafeValue } from "../logic";
import { jsx as _jsx } from "react/jsx-runtime";
var CreatableSelect = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var css = _ref.css,
    asChild = _ref.asChild,
    as = _ref.as,
    style = _ref.style,
    className = _ref.className,
    options = _ref.options,
    name = _ref.name,
    onChange = _ref.onChange,
    id = _ref.id,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onCreateOption = _ref.onCreateOption,
    value = _ref.value,
    hideDropdownIndicator = _ref.hideDropdownIndicator,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    openMenuOnClick = _ref.openMenuOnClick,
    renderOption = _ref.renderOption,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? "auto" : _ref$menuPlacement,
    _ref$menuPosition = _ref.menuPosition,
    menuPosition = _ref$menuPosition === void 0 ? "absolute" : _ref$menuPosition,
    _ref$portalMenu = _ref.portalMenu,
    portalMenu = _ref$portalMenu === void 0 ? false : _ref$portalMenu,
    icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  var disabledOptions = function disabledOptions(option) {
    return option.disabled;
  };
  var _useGetCustomComponen = useGetCustomComponents({
      hideDropdownIndicator: hideDropdownIndicator,
      component: "creatableSelect"
    }),
    customComponents = _useGetCustomComponen.customComponents,
    styles = _useGetCustomComponen.styles;
  var safeValue = useMemo(function () {
    return getSafeValue(value, options, isMulti, "CreatableSelect");
  }, [value, options, isMulti]);
  var menuPositionProps = useMenuPositionProps(menuPlacement, menuPosition, portalMenu);
  return /*#__PURE__*/_jsx(Creatable, _extends({
    id: id,
    onCreateOption: onCreateOption
    // does a check for value and if it exists, it will return the safeValue if it does other wise passes null to allow the component to function uncontrolled
    ,
    value: value && safeValue,
    name: name,
    onChange: onChange,
    ref: forwardedRef,
    options: options,
    openMenuOnClick: openMenuOnClick,
    isDisabled: disabled,
    isOptionDisabled: disabledOptions,
    "aria-invalid": hasError,
    isClearable: true,
    isMulti: isMulti,
    styles: styles,
    components: customComponents // inner components that have been customised
    ,
    unstyled: true,
    renderOption: renderOption,
    icon: icon
  }, menuPositionProps, props));
});
CreatableSelect.displayName = "CreatableSelect";
export default CreatableSelect;